webpackJsonp([85],{

/***/ "+cgv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/5QB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var _globalMethod = {
  install: function install(Vue) {
    Vue.prototype.addClass = function (obj, newClass) {
      if (!this.hasClass(obj, newClass)) {
        //如果obj没有这个类，才添加
        var obj_class = obj.className; //获取 class 内容.
        var blank = obj_class != '' ? ' ' : ''; //判断获取到的 class 是否为空, 如果不为空在前面加个'空格'.
        var added = obj_class + blank + newClass; //组合原来的 class 和需要添加的 class.
        obj.className = added; //替换原来的 class.
      }
    }, Vue.prototype.removeClass = function (obj, newClass) {
      var obj_class = ' ' + obj.className + ' '; //获取 class 内容, 并在首尾各加一个空格. ex) 'abc    bcd' -> ' abc    bcd '
      obj_class = obj_class.replace(/(\s+)/gi, ' '); //将多余的空字符替换成一个空格. ex) ' abc    bcd ' -> ' abc bcd '
      var removed = obj_class.replace(' ' + newClass + ' ', ' '); //在原来的 class 替换掉首尾加了空格的 class. ex) ' abc bcd ' -> 'bcd '
      removed = removed.replace(/(^\s+)|(\s+$)/g, ''); //去掉首尾空格. ex) 'bcd ' -> 'bcd'
      obj.className = removed; //替换原来的 class.
    }, Vue.prototype.hasClass = function (elem, cls) {
      cls = cls || '';
      if (cls.replace(/\s/g, '').length == 0) return false; //当cls没有参数时，返回false
      return new RegExp(' ' + cls + ' ').test(' ' + elem.className + ' ');
    }, Vue.prototype.duplicate = function (_array) {
      //数组去重
      //console.log("去重");
      var r = [];
      for (var i = 0, l = _array.length; i < l; i++) {
        for (var j = i + 1; j < l; j++) {
          if (_array[i] === _array[j]) j = ++i;
        }r.push(_array[i]);
      }
      return r;
    }, Vue.prototype.dataRepeat = function (_array, data) {
      //检测数组中的最后一个元素之前重复出现过没
      var onOff = false;
      for (var i = 0; i < _array.length - 1; i++) {
        if (data == _array[i]) {
          onOff = true;
        }
      }
      return onOff;
    }, Vue.prototype.sortToFirst = function (_array, cus_attr) {
      //如果数组元素中的cusindex等于cus_attr,就把这个元素放置到最前
      var obj_temp;
      for (var i = 0; i < _array.length; i++) {
        if (_array[i].cusindex == cus_attr) {
          obj_temp = _array[i];
          _array.splice(i, 1);
        }
      }
      _array.unshift(obj_temp);
    },
    //自动触发iNow_cusindex的click事件
    Vue.prototype.iNow_cusindex = function (_array, data) {
      for (var i = 0; i < _array.length; i++) {
        if (_array[i] == data) {
          return _array[i + 1];
        }
      }
    },
    //清除所有导航的高亮
    Vue.prototype.clearHighLight = function (ele) {
      for (var i = 0; i < ele.length; i++) {
        //清除所有的高亮
        this.removeClass(ele[i], "is-active");
      }
    },
    //给特定导航加上高亮
    Vue.prototype.fixedAddHighLight = function (ele, cusindex) {
      for (var i = 0; i < ele.length; i++) {
        if (ele[i].getAttribute("cusindex") == cusindex) {
          this.addClass(ele[i], "is-active");
          break;
        }
      }
    },
    //简单一行提示语
    Vue.prototype.simpleNotice = function (text) {
      var html = "";
      var simpleNotice = $('<div class="popup-alone popup-alone-line">' + '<div class="popup-a-n-bg"></div>' + '<div class="popup-a-n-content">' + '<div class="popup-del"></div>' + '<div class="alone-line-text">' + text + '</div>' + '<div class="popup-btn-sure">确定</div>' + '</div>' + '</div>');
      $("body").append(simpleNotice);
    },
    //tab标签右键
    Vue.prototype.contextMenus = function (jq_ele) {
      var contentMenuPre = $("body").find(".contextLists");
      contentMenuPre.remove();
      var contextMenus = $('<div class="contextLists contextLists-right">' + '<div class="context-close"></div>' + '<div class="contextListsSub close-current">关闭当前页面</div>' + '<div class="contextListsSub close-other">关闭其他页面</div>' + '<div class="contextListsSub close-all">关闭所有页面</div>' + '</div>');
      //获取导入jq元素的特定位置：右键菜单的左上角或者右上角位于该特定位置
      var ele_top = jq_ele.offset().top;
      var ele_left = jq_ele.offset().left;
      var ele_wid = jq_ele.width();
      var ele_height = jq_ele.height();
      var pos_menu_top = ele_top + ele_height * 3 / 4; //菜单最终的top位置
      var pos_menu_left = ele_left + ele_wid / 2; //菜单最终的left位置
      contextMenus.offset({ top: pos_menu_top, left: pos_menu_left });
      $("body").append(contextMenus);
    },
    //右键菜单点击效果
    Vue.prototype.clickIndex = function (callBack, cusindex, parentindex, cusEvent) {
      //右键弹窗关闭
      $(".context-close").off("click").on("click", function () {
        $(this).parent().remove();
      });
      //定义返回值: 0->关闭当前页面  1->关闭其他页面  2->关闭所有页面
      var click_index;
      $(document).off("click", ".contextLists .close-current").on("click", ".contextLists .close-current", function () {
        click_index = 0;
        var contentMenuPre = $("body").find(".contextLists");
        contentMenuPre.remove();
        callBack && callBack(cusindex, click_index, parentindex, cusEvent);
      });
      $(document).off("click", ".contextLists .close-other").on("click", ".contextLists .close-other", function () {
        click_index = 1;
        var contentMenuPre = $("body").find(".contextLists");
        contentMenuPre.remove();
        callBack && callBack(cusindex, click_index, parentindex, cusEvent);
      });
      $(document).off("click", ".contextLists .close-all").on("click", ".contextLists .close-all", function () {
        click_index = 2;
        var contentMenuPre = $("body").find(".contextLists");
        contentMenuPre.remove();
        callBack && callBack(cusindex, click_index, parentindex, cusEvent);
      });
    },
    //删除数组中重复的数据

    //table项公共事件-------------------start
    //判断至少有一个checkbox选中
    Vue.prototype.orOneCheck = function (array) {
      var checkOnOff = false;
      for (var i = 0; i < array.length; i++) {
        if (array[i].checkbox) {
          checkOnOff = true;
        }
      }
      return checkOnOff;
    },
    //判断数组元素中被选中的个数
    Vue.prototype.getNumCheck = function (array) {
      var number = 0;
      for (var i = 0; i < array.length; i++) {
        if (array[i].checkbox) {
          number++;
        }
      }
      return number;
    },
    //清空数组中所有的选中状态
    Vue.prototype.emptyCheckbox = function (array) {
      for (var i = 0; i < array.length; i++) {
        array[i].checkbox = false;
      }
    },
    //获取选中checkbox对应table数据中对应的唯一id值:其中idName是唯一的那个数据，传入这个值，是因为后端给的数据，唯一的id名有可能不一样
    Vue.prototype.getCheckID = function (array, idName) {
      for (var i = 0; i < array.length; i++) {
        if (array[i].checkbox) {
          return array[i][idName];
        }
      }
    },
    //获取所有选中项的idName
    Vue.prototype.getAllCheckID = function (array, idName) {
      var array_temp = [];
      for (var i = 0; i < array.length; i++) {
        if (array[i].checkbox) {
          array_temp.push(array[i][idName]);
        }
      }
      return array_temp;
    },
    //通用版本管理->审核：idName:父组件中唯一的id值;ObtainIdname:父组件根据选择框之后传入子组件的唯一id值
    // state:大数据中状态对应的字段;examine:审核通过或者不通过的值;其中idName是唯一的那个数据，state是状态值，是因为后端给的数据，唯一的id名有可能不一样
    Vue.prototype.modifyCheckID = function (array, idName, ObtainIdname, state, examine_state) {
      for (var i = 0; i < array.length; i++) {
        if (array[i][idName] == ObtainIdname) {
          array[i][state] = examine_state;
        }
      }
    }, Vue.prototype.getiNowCusindex = function () {
      //获取当前点击导航的cusindex,通过该值，需要遍历基础数据表找到对应cusindex的数据

      /*刷新调整--start*/
      var nav_iNow;
      var get_session_nav_iNow = sessionStorage.getItem("session_active_iNow");
      if (get_session_nav_iNow) {
        this.$store.commit("setiNow", get_session_nav_iNow); //根据sessionStorage同步active_iNow
      }
      nav_iNow = this.$store.getters.get_iNow;
      /*刷新调整----end*/

      return nav_iNow;
    }, Vue.prototype.getiNowData = function () {
      /*刷新调整--start*/
      var nav_router;
      var get_session_nav_router = JSON.parse(sessionStorage.getItem("session_nav_router")); //获取所有的数据
      if (get_session_nav_router) {
        //this.$store.commit("setNavList",get_session_nav_router);//根据sessionStorage同步nav_router
        nav_router = get_session_nav_router;
      } else {
        nav_router = this.$store.getters.get_nav_list; //获取所有的数据
      }
      /*刷新调整----end*/
      return nav_router;
    },
    //清空所有左侧导航高亮
    Vue.prototype.emptyHighlightNav = function () {
      var nav_list_total = document.getElementsByClassName("cus-nav");
      for (var i = 0; i < nav_list_total.length; i++) {
        this.removeClass(nav_list_total[i], "is-active");
      }
    },
    //重置sessionStorage中的数据
    Vue.prototype.emptySessionStorage = function () {
      /*刷新调整--start*/
      var active_nav_temp = [];
      sessionStorage.setItem("session_active_nav", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(active_nav_temp)); //根据vueX中的active_nav初始值,储存到sessionStorage

      var active_iNow_temp = "";
      sessionStorage.setItem("session_active_iNow", active_iNow_temp); //根据vueX中的active_iNow初始值,储存到sessionStorage

      var carData_temp = [];
      sessionStorage.setItem("session_carData", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(carData_temp)); //根据vueX中的carData初始值,储存到sessionStorage

      var accountData_temp = [];
      sessionStorage.setItem("session_accountData", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(accountData_temp)); //根据vueX中的accountData初始值,储存到sessionStorage

      var productWarranty_temp = [];
      sessionStorage.setItem("session_productWarranty", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(productWarranty_temp)); //根据vueX中的productWarranty初始值,储存到sessionStorage

      var productAuthorize_temp = [];
      sessionStorage.setItem("session_productAuthorize", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(productAuthorize_temp)); //根据vueX中的productAuthorize初始值,储存到sessionStorage

      var historyAuthorize_temp = [];
      sessionStorage.setItem("session_historyAuthorize", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(historyAuthorize_temp)); //根据vueX中的historyAuthorize初始值,储存到sessionStorage

      var machineNewOnOff_temp = true;
      sessionStorage.setItem("session_machineNewOnOff", machineNewOnOff_temp); //根据vueX中的machineNewOnOff初始值,储存到sessionStorage

      var tabVisible_temp = this.$store.getters.get_tabVisible_original; //获取Vuex中的跨模块数据
      sessionStorage.setItem("session_tabVisible", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(tabVisible_temp)); //根据vueX中的tabVisible初始值,储存到sessionStorage

      sessionStorage.setItem("session_Configid", "");
      sessionStorage.setItem("session_Route", "");
      /*刷新调整----end*/
    },
    //点击关闭tab标签后，触发点击上一个或者下一个tab
    Vue.prototype.triggerClick = function (jq_ele, cusindex) {
      for (var i = 0; i < jq_ele.length; i++) {
        //tab切换页点击
        if (jq_ele[i].getAttribute("cusindex") == cusindex) {
          jq_ele[i].click();
          break;
        }
      }
    },
    //车型数据授权、用户账号列表等查看子项的路由参数
    Vue.prototype.pubConfigID = function (paramConfigID) {
      var targetConfitID;
      var configIDTemp = sessionStorage.getItem("session_Configid");
      var pageRefreshOnOff = this.$store.getters.get_pageRefreshOnOff; //获取Vuex中的跨模块数据
      //如果是正常切换，就用vuex中的数据
      if (pageRefreshOnOff) {
        targetConfitID = paramConfigID;
        //如果是刷新，就用sessionStorage中的数据
      } else {
        if (configIDTemp) {
          targetConfitID = configIDTemp;
        }
      }
      return targetConfitID;
    },
    //车型数据授权、用户账号列表等查看子项的路由参数
    Vue.prototype.pubConfigAPI = function (paramConfigAPI) {
      var targetConfitApi;
      var configIDTemp = sessionStorage.getItem("session_Route");
      var pageRefreshOnOff = this.$store.getters.get_pageRefreshOnOff; //获取Vuex中的跨模块数据
      //如果是正常切换，就用vuex中的数据
      if (pageRefreshOnOff) {
        targetConfitApi = paramConfigAPI;
        //如果是刷新，就用sessionStorage中的数据
      } else {
        if (configIDTemp) {
          targetConfitApi = configIDTemp;
        }
      }
      return targetConfitApi;
    },
    //车型数据授权、用户账号列表等查看子项的路由参数
    Vue.prototype.pubConfigName = function (paramConfigName) {
      var targetConfitName;
      var configNameTemp = sessionStorage.getItem("session_transmitName");
      var pageRefreshOnOff = this.$store.getters.get_pageRefreshOnOff; //获取Vuex中的跨模块数据
      //如果是正常切换，就用vuex中的数据
      if (pageRefreshOnOff) {
        targetConfitName = paramConfigName;
        //如果是刷新，就用sessionStorage中的数据
      } else {
        if (configNameTemp) {
          targetConfitName = configNameTemp;
        }
      }
      return targetConfitName;
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ _globalMethod: _globalMethod });
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "/WR1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  active_nav: [], //记录所有用户点击过的导航，包括之前有重复的点击,tab标签的显示就是根据该数组中的内容决定
  active_iNow: "", //当前点击导航的cusindex,主要用于点击导航，切换到相应路由
  carData: [], //车型数据->查看记录 tab页:点击前子项链接onoff=true,点击打开后为false,关闭该tab标签后,onoff=true;该数组是tab页上还保留着的配置项子项cusindex集合
  accountData: [], //用户账号列表->查看 tab页:点击前子项链接onoff=true,点击打开后为false,关闭该tab标签后,onoff=true;该数组是tab页上还保留着的查看项子项cusindex集合
  machineNewOnOff: true, //售机类型管理->在售机型->添加 ：当一个添加tab页打开时候，该值就设置为false;关闭该tab页时，该值设置为true
  productWarranty: [], //用户账号列表->查看详情->产品保修信息 tab页:点击前子项链接onoff=true,点击打开后为false,关闭该tab标签后,onoff=true;该数组是tab页上还保留着的查看项子项cusindex集合
  productAuthorize: [], //用户账号列表->查看详情->授权 tab页:点击前子项链接onoff=true,点击打开后为false,关闭该tab标签后,onoff=true;该数组是tab页上还保留着的查看项子项cusindex集合
  historyAuthorize: [], //用户账号列表->查看详情->授权->历史记录 tab页:点击前子项链接onoff=true,点击打开后为false,关闭该tab标签后,onoff=true;该数组是tab页上还保留着的查看项子项cusindex集合
  pageRefreshOnOff: false, //由于f5刷新 需要用sessionStorage记住一些信息；但是刷新之后，需要将该值设置为true
  tabVisible: [//pub-head中左边导航与右边tab页的对应数据，因为售机类型配置项可以添加tab，所以会跨模块
  {
    cusindex: "cusindex00",
    cusname: "固件版本管理",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex01",
    cusname: "APP管理",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex02",
    cusname: "扩展文件管理",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex03",
    cusname: "整机产品",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex10",
    cusname: "多语言管理",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex11",
    cusname: "ECU刷写包",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex12",
    cusname: "汽车索引",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex13",
    cusname: "历史车型数据",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex14",
    cusname: "车型数据授权",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex20",
    cusname: "车系维护",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex21",
    cusname: "车组维护",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex22",
    cusname: "车型维护",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex23",
    cusname: "车型文件",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex24",
    cusname: "新版车系维护",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex25",
    cusname: "新版车组维护",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex26",
    cusname: "新版车型维护",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  },
  /*{
      cusindex: "cusindex30",
      cusname: "一键同步",
      orShow: false,
      isActive: false,
      routerName: null,
      ourRouter: null
  },*/

  {
    cusindex: "cusindex15",
    cusname: "康明斯刷写",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex16",
    cusname: "博世刷写",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex17",
    cusname: "德尔福刷写",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex18",
    cusname: "马牌刷写",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex19",
    cusname: "南岳刷写",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex40",
    cusname: "已售设备",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex50",
    cusname: "用户账号列表",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex27",
    cusname: "设备授权",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex51",
    cusname: "投诉列表",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex28",
    cusname: "诊断报告",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex52",
    cusname: "新闻管理",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex53",
    cusname: "产品管理",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex54",
    cusname: "固件",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex55",
    cusname: "app",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex56",
    cusname: "车型",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex57",
    cusname: "图片管理",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex58",
    cusname: "视频管理",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex59",
    cusname: "技术服务",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex60",
    cusname: "技术信息",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex61",
    cusname: "公司联系方式",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex62",
    cusname: "信息管理",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }],
  tabVisible_original: [//tabVisible数据备份，因为tab右键关闭所有标签页之后，需要重置该值
  {
    cusindex: "cusindex00",
    cusname: "固件版本管理",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex01",
    cusname: "APP管理",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex02",
    cusname: "扩展文件管理",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex03",
    cusname: "整机产品",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex10",
    cusname: "多语言管理",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex11",
    cusname: "汽车品牌",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex12",
    cusname: "汽车索引",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex13",
    cusname: "历史车型数据",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex14",
    cusname: "车型数据授权",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex20",
    cusname: "车系维护",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex21",
    cusname: "车组维护",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex22",
    cusname: "车型维护",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex23",
    cusname: "车型文件",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex24",
    cusname: "新版车系维护",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex25",
    cusname: "新版车组维护",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex26",
    cusname: "新版车型维护",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  },
  /*{
    cusindex: "cusindex30",
    cusname: "一键同步",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  },*/
  {
    cusindex: "cusindex15",
    cusname: "康明斯刷写",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex16",
    cusname: "博世刷写",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex17",
    cusname: "德尔福刷写",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex18",
    cusname: "马牌刷写",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex19",
    cusname: "南岳刷写",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex40",
    cusname: "已售设备",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex50",
    cusname: "用户账号列表",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex27",
    cusname: "设备授权",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex51",
    cusname: "投诉列表",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex28",
    cusname: "诊断报告",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex52",
    cusname: "新闻管理",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex53",
    cusname: "产品管理",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex54",
    cusname: "固件",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex55",
    cusname: "app",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex56",
    cusname: "车型",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex57",
    cusname: "图片管理",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex58",
    cusname: "视频管理",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex59",
    cusname: "技术服务",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex60",
    cusname: "技术信息",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex61",
    cusname: "公司联系方式",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }, {
    cusindex: "cusindex62",
    cusname: "信息管理",
    orShow: false,
    isActive: false,
    routerName: null,
    ourRouter: null
  }]
});

/***/ }),

/***/ "3f40":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4qOc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "60be":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__states_js__ = __webpack_require__("/WR1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters_js__ = __webpack_require__("VQfc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations_js__ = __webpack_require__("bqLE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_js__ = __webpack_require__("aubk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__actions_js__);

//import Vuex

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);






var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: __WEBPACK_IMPORTED_MODULE_2__states_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_3__getters_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_4__mutations_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_5__actions_js___default.a
});
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "DYHi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5002c00f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("S3ap");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5002c00f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_quill_dist_quill_core_css__ = __webpack_require__("3f40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_quill_dist_quill_snow_css__ = __webpack_require__("4qOc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_quill_dist_quill_snow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_quill_dist_quill_bubble_css__ = __webpack_require__("+cgv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_quill_dist_quill_bubble_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_quill_dist_quill_bubble_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_javascripts_vue_public_js__ = __webpack_require__("/5QB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_javascripts_url_public__ = __webpack_require__("k3yR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_es6_promise__ = __webpack_require__("hKoQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_lazyload__ = __webpack_require__("cTzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_less_main_less__ = __webpack_require__("DYHi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_less_main_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_less_main_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_vuex_store_js__ = __webpack_require__("60be");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_routers_index_js__ = __webpack_require__("ath6");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui___default.a);
// import 'element-ui/lib/theme-default/index.css'

// import axios

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$ajax = __WEBPACK_IMPORTED_MODULE_4_axios___default.a;

/*import 'element-ui/lib/theme-default/index.css'
import {Input,
        Col,
        Menu,
        Submenu,
        MenuItem,
        MenuItemGroup,
        Autocomplete,
        DatePicker,
        Select,
        Option,
        Button,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Tree,
        Form,
        FormItem,
        Switch,
        Pagination,
        Tabs,
        TabPane,
        Cascader,
        Upload,
        Message,
        MessageBox,
        Table
        } from 'element-ui'
var useObj= {
  Input,
  Upload,
  Col,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Autocomplete,
  DatePicker,
  Select,
  Option,
  Button,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Tree,
  Form,
  FormItem,
  Switch,
  Pagination,
  Tabs,
  TabPane,
  Cascader,
  Table
};
for(var prop in useObj){
  Vue.use( useObj[prop] )
}*/




//引入全局方法

for (var prop in __WEBPACK_IMPORTED_MODULE_8__assets_javascripts_vue_public_js__["a" /* default */]) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8__assets_javascripts_vue_public_js__["a" /* default */][prop]);
}

// Vue.component(MessageBox);
// Vue.component(Message);
// Vue.prototype.$msgbox = MessageBox;
// Vue.prototype.$alert = MessageBox.alert;
// Vue.prototype.$confirm = MessageBox.confirm;
// Vue.prototype.$prompt = MessageBox.prompt;
// Vue.prototype.$message = Message;



//import es6-promise

__WEBPACK_IMPORTED_MODULE_10_es6_promise___default.a.polyfill();

// 引入全部echarts
/*import echarts from 'echarts'*/

// 按需引入引入基本模板
var echarts = __webpack_require__("Icdr");
// 引入柱状图组件
__webpack_require__("GbHy");
// 引入提示框和title组件
__webpack_require__("Oq2I");
__webpack_require__("miEh");
__webpack_require__("YsUA");

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$echarts = echarts;

//import VueLazyload
 //懒加载插件https://github.com/hilongjw/vue-lazyload
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_lazyload___default.a, {
  loading: "src/assets/images/app.png"
});

//import APP


//import MAIN.less(这里可以放置一些固有样式,比如样式重置)




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;



/* eslint-disable no-new */
//选择第一个
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("checkFirst", function (originalData) {
  for (var i = 0; i < originalData.length; i++) {
    if (originalData[i].checkbox) {
      return originalData[i];
    }
  }
});
//标准时间转换成时间戳 时间格式:'yyyy-MM-dd h:m:s'
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("cus_time_stamp", function (originalData) {
  var transData = new Date(originalData); // 将指定日期转换为标准日期格式。Fri Dec 08 2017 20:05:30 GMT+0800 (中国标准时间)
  return transData.getTime(); // 将转换后的标准日期转换为时间戳。
});

//格式化具体时间,格式化后样式为：'yyyy-MM-dd h:m:s'
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("format_time", function (originalData) {
  var date = new Date(Number(originalData));
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  var d = date.getDate();
  d = d < 10 ? '0' + d : d;
  var h = date.getHours();
  h = h < 10 ? '0' + h : h;
  var minute = date.getMinutes();
  var second = date.getSeconds();
  minute = minute < 10 ? '0' + minute : minute;
  second = second < 10 ? '0' + second : second;
  return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
});
//elementUI的时间空间返回的值:2018-04-07T16:00:00.000Z,需要将其处理成2018-04-07 00:00:00


new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_14__assets_vuex_store_js__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_15__assets_routers_index_js__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_12__App__["a" /* default */] }
});

/***/ }),

/***/ "S3ap":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VQfc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  //获取用户点击过的所有导航
  get_active_nav: function get_active_nav(state) {
    return state.active_nav;
  },
  //获取当前点击的导航
  get_iNow: function get_iNow(state) {
    return state.active_iNow;
  },
  //获取tab标签页的基础数据,该数据会根据tab标签的改变而做出相应改变
  get_tabVisible: function get_tabVisible(state) {
    return state.tabVisible;
  },
  //获取跨模块的原始固定数据
  get_tabVisible_original: function get_tabVisible_original(state) {
    return state.tabVisible_original;
  },
  //获取车型数据授权子项tab页
  get_carData: function get_carData(state) {
    return state.carData;
  },
  //获取 用户账号列表 子项tab页
  get_accountData: function get_accountData(state) {
    return state.accountData;
  },
  //获取 在售机型子项tab页的machineNewOnOff
  get_machineNewOnOff: function get_machineNewOnOff(state) {
    return state.machineNewOnOff;
  },
  //获取 用户账号列表 产品保修信息
  get_productWarranty: function get_productWarranty(state) {
    return state.productWarranty;
  },
  //获取 用户账号列表 授权
  get_productAuthorize: function get_productAuthorize(state) {
    return state.productAuthorize;
  },
  //获取 用户账号列表 授权
  get_historyAuthorize: function get_historyAuthorize(state) {
    return state.historyAuthorize;
  },
  //页面刷新时,启用sessionStorage的开关
  get_pageRefreshOnOff: function get_pageRefreshOnOff(state) {
    return state.pageRefreshOnOff;
  }
});

/***/ }),

/***/ "ath6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/**
 * Created by xiaojiang on 2017/10/30.
 */


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

//登录页
var sign_page = function sign_page(resolve) {
  return __webpack_require__.e/* require */(65).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0h59")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//引导页
var root_page = function root_page(resolve) {
  return __webpack_require__.e/* require */(72).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("VjrR")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//主页
var home_page = function home_page(resolve) {
  return __webpack_require__.e/* require */(78).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MRGU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//官网后台页面
var official_network = function official_network(resolve) {
  return __webpack_require__.e/* require */(83).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("UWS9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//主页->导航+内容路由容器
var main_page = function main_page(resolve) {
  return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("TyLo")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//主页->公共头部
var pub_head = function pub_head(resolve) {
  return __webpack_require__.e/* require */(62).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("TWKe")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//产品管理->固件版本管理
var firmware_version = function firmware_version(resolve) {
  return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+SbR")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//产品管理->APP管理
var app_manage = function app_manage(resolve) {
  return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("kbb1")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//产品管理->拓展文件管理->拓展文件类型
var extension_doc = function extension_doc(resolve) {
  return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("96bG")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//产品管理->拓展文件管理->拓展文件信息
var extension_infor = function extension_infor(resolve) {
  return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Wqsk")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//产品管理->整机产品
var machine_type = function machine_type(resolve) {
  return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("PtcR")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var machine_type_add = function machine_type_add(resolve) {
  return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("593e")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//电子资料->汽油资料库
var gasoline_data = function gasoline_data(resolve) {
  return __webpack_require__.e/* require */(69).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ecrs")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//电子资料->柴油资料库
var diesel_data = function diesel_data(resolve) {
  return __webpack_require__.e/* require */(70).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("JbRI")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//汽车管理->多语言管理
var multi_language = function multi_language(resolve) {
  return __webpack_require__.e/* require */(50).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/HcY")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//汽车管理->汽车品牌
var automobile_brand = function automobile_brand(resolve) {
  return __webpack_require__.e/* require */(79).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MSKe")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//汽车管理->汽车索引
var auto_indexing = function auto_indexing(resolve) {
  return __webpack_require__.e/* require */(60).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xHr+")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//老版车型管理->车系维护
var car_maintain = function car_maintain(resolve) {
  return __webpack_require__.e/* require */(71).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("6v0P")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//老版车型管理->车组维护
var emu_maintain = function emu_maintain(resolve) {
  return __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jFjp")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//老版车型管理->车型维护
var models_maintain = function models_maintain(resolve) {
  return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("gwLA")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//老版车型管理->车型文件
var models_file = function models_file(resolve) {
  return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/Q+1")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//新版车型管理->新版车系维护
var car_care_new = function car_care_new(resolve) {
  return __webpack_require__.e/* require */(49).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("QSKU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//新版车型管理->新版车组维护
var emu_care_new = function emu_care_new(resolve) {
  return __webpack_require__.e/* require */(48).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("iBUi")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//新版车型管理->新版车型维护
var models_care_new = function models_care_new(resolve) {
  return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HrtW")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//新版车型管理->新版车型文件维护
var models_car_file = function models_car_file(resolve) {
  return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("RHB0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//新版车型管理->新版车标类型维护
var logo_type = function logo_type(resolve) {
  return __webpack_require__.e/* require */(59).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("CRwM")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//新版车型管理->新版车标文件维护
var logo_file = function logo_file(resolve) {
  return __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ItoX")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//ECU刷写->康明斯刷写
var KMS_data_package = function KMS_data_package(resolve) {
  return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("S0PS")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var data_up_page = function data_up_page(resolve) {
  return __webpack_require__.e/* require */(54).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("65tn")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//ECU刷写->博世刷写
var BS_data_package = function BS_data_package(resolve) {
  return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NXpy")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//ECU刷写->德尔福刷写
var Other_data_package = function Other_data_package(resolve) {
  return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("T75G")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//ECU刷写->马牌刷写
var MP_data_package = function MP_data_package(resolve) {
  return __webpack_require__.e/* require */(53).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("n0t8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//ECU刷写->南岳刷写
var NY_data_package = function NY_data_package(resolve) {
  return __webpack_require__.e/* require */(52).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("i9xb")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//ECU用户上传数据
var user_upload = function user_upload(resolve) {
  return __webpack_require__.e/* require */(82).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ZwMV")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//已售设备管理->已售设备
var sold_equipment = function sold_equipment(resolve) {
  return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("fUrd")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//已授权管理
var userAccredit = function userAccredit(resolve) {
  return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wRzp")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var sold_equipment_new = function sold_equipment_new(resolve) {
  return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("EYjY")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
//已售设备管理->设备授权->固件授权
var firmware_accredit_sold = function firmware_accredit_sold(resolve) {
  return __webpack_require__.e/* require */(56).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("etUl")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
//已售设备管理->设备授权->app授权
var app_accredit_sold = function app_accredit_sold(resolve) {
  return __webpack_require__.e/* require */(57).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("at1b")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
//已售设备管理->设备授权->扩展文件授权
var extend_accredit_sold = function extend_accredit_sold(resolve) {
  return __webpack_require__.e/* require */(74).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("aDJD")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
//已售设备管理->设备授权->车型文件授权
var model_accredit_sold = function model_accredit_sold(resolve) {
  return __webpack_require__.e/* require */(73).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("cGNh")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//软件同步管理->一键同步
var sync_manage = function sync_manage(resolve) {
  return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ACeh")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//用户管理->用户账号列表
var user_manage = function user_manage(resolve) {
  return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("A/Uu")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
//用户管理->用户账号列表->查看记录
// const account_data_record = resolve => require(['../../components/main/user-manage/user-manage-sub/account-data-record.vue'], resolve)
//用户管理->用户账号列表->查看记录->个人详情
var checkDetail_config = function checkDetail_config(resolve) {
  return __webpack_require__.e/* require */(66).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("VfgI")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
//用户管理->用户账号列表->查看记录->授权
var authorize_config = function authorize_config(resolve) {
  return __webpack_require__.e/* require */(67).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Te8S")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
//用户管理->用户账号列表->查看记录->授权->历史记录
var record_config = function record_config(resolve) {
  return __webpack_require__.e/* require */(68).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SF+R")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//授权管理->设备授权
var equipment_accredit = function equipment_accredit(resolve) {
  return __webpack_require__.e/* require */(61).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("BAn/")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
//投诉管理->设备授权->固件授权
var firmware_accredit = function firmware_accredit(resolve) {
  return __webpack_require__.e/* require */(63).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ilET")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
//投诉管理->设备授权->app授权
var app_accredit = function app_accredit(resolve) {
  return __webpack_require__.e/* require */(64).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("eNRK")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
//投诉管理->设备授权->扩展文件授权
var extend_accredit = function extend_accredit(resolve) {
  return __webpack_require__.e/* require */(81).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("D0bM")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
//投诉管理->设备授权->车型文件授权
var model_accredit = function model_accredit(resolve) {
  return __webpack_require__.e/* require */(80).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Qniz")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
//投诉管理->设备授权->已售设备查看
var granted = function granted(resolve) {
  return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jWcL")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//投诉管理->投诉列表
var appeal_manage = function appeal_manage(resolve) {
  return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/IMz")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//诊断管理->诊断报告
var diagnostic_report = function diagnostic_report(resolve) {
  return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("41Gc")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//英文官网管理->新闻管理
var news_manage = function news_manage(resolve) {
  return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("BMIH")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//英文官网管理->产品管理
var product_manage = function product_manage(resolve) {
  return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("At7e")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//英文官网管理->图片管理
var photo_manage = function photo_manage(resolve) {
  return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("M3i+")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//英文官网管理->视屏管理
var video_manage = function video_manage(resolve) {
  return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("KwFl")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//安徽官网管理->新闻管理
var anhui_news_manage = function anhui_news_manage(resolve) {
  return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Hbrl")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//安徽官网管理->产品管理
var anhui_product_manage = function anhui_product_manage(resolve) {
  return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("QM/o")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// const anhui_product_manage = resolve => require(['../../components/main/Chinese-website-manage/product-manage.vue'], resolve)

//安徽官网管理->图片管理
var anhui_photo_manage = function anhui_photo_manage(resolve) {
  return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("FkoR")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//安徽官网管理->经销商管理
var anhui_video_manage = function anhui_video_manage(resolve) {
  return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Hn8H")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//安徽官网管理->招聘信息
var anhui_recruit_manage = function anhui_recruit_manage(resolve) {
  return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+Up5")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//安徽官网管理->信息查询
var anhui_infomation_manage = function anhui_infomation_manage(resolve) {
  return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("akKh")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//安徽官网管理->服务介绍
var anhui_bussiness_manage = function anhui_bussiness_manage(resolve) {
  return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("yyfn")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//俄文官网管理->新闻管理
var Russian_news = function Russian_news(resolve) {
  return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ojhm")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//俄文官网管理->产品管理
var Russian_product = function Russian_product(resolve) {
  return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("UsDs")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//俄文官网管理->图片管理
var Russian_photo = function Russian_photo(resolve) {
  return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1RwC")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//俄文官网管理->视频管理
var Russian_video = function Russian_video(resolve) {
  return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MTVq")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var Russian_information = function Russian_information(resolve) {
  return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("URXG")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var Russian_services = function Russian_services(resolve) {
  return __webpack_require__.e/* require */(51).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wnm1")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

/*const Russian_information = resolve => require(['../../components/main/Russian-website-manage/technical-information.vue'], resolve)

const Russian_concat = resolve => require(['../../components/main/Russian-website-manage/company-concat.vue'], resolve)
*/

//中文官网-> 新闻管理
var Chinese_news = function Chinese_news(resolve) {
  return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("sFzv")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//中文官网 -> 图片管理
var Chinese_photo = function Chinese_photo(resolve) {
  return __webpack_require__.e/* require */(55).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("4YEz")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//中文官网 -> 产品管理
var Chinese_product = function Chinese_product(resolve) {
  return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("kA9B")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//中文官网 -> 年报
var Chinese_report = function Chinese_report(resolve) {
  return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("uFzI")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//中文官网 -> 通知
var Chinese_Notice = function Chinese_Notice(resolve) {
  return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("VcQ8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//中文官网 -> 招聘信息
var Chinese_Recruit = function Chinese_Recruit(resolve) {
  return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("aT/l")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//中文官网 -> 信息查询
var Chinese_search = function Chinese_search(resolve) {
  return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("21u5")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//中文官网 -> 服务介绍
var Chinese_Business = function Chinese_Business(resolve) {
  return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/+DK")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//软件同步->固件
var firmware_synchronous = function firmware_synchronous(resolve) {
  return __webpack_require__.e/* require */(75).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("P4VD")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//软件同步->app
var app_synchronous = function app_synchronous(resolve) {
  return __webpack_require__.e/* require */(77).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("BQCu")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//软件同步->car
var car_synchronous = function car_synchronous(resolve) {
  return __webpack_require__.e/* require */(76).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("9xe7")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//故障码->柴油故障码
var diesel_fault = function diesel_fault(resolve) {
  return __webpack_require__.e/* require */(58).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("KD48")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

//换机数据->换机数据
var change_machine = function change_machine(resolve) {
  return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("tqC4")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  // base:'FcarOperateWeb',
  // mode:'history',/*特别注意：history模式打包上线后，需要后台配置*/

  routes: [{
    path: "/",
    redirect: "/login2"
  }, {
    path: "/login2",
    component: sign_page
  }, {
    path: "/main-page",
    component: main_page,
    children: [{
      path: "/",
      redirect: "/index"
    }, {
      path: "/index",
      component: root_page
    }, {
      path: "/home-page",
      component: home_page
    }, {
      path: "/official-network",
      component: official_network
    }, {
      path: "pub-head",
      component: pub_head,
      children: [{
        path: "machine-type-add", //产品管理->固件版本管理
        component: machine_type_add
      }, {
        path: "firmware-version", //产品管理->固件版本管理
        component: firmware_version
      }, {
        path: "app-manage", //产品管理->APP管理
        component: app_manage
      }, {
        path: "extension-doc", //产品管理->扩展文件管理
        component: extension_doc
      }, {
        path: "extension-infor", //产品管理->扩展文件管理
        component: extension_infor
      }, {
        path: "machine-type", //产品管理->整机产品
        component: machine_type
      }, {
        path: "gasoline-data", //电子资料->汽油资料库
        component: gasoline_data
      }, {
        path: "diesel-data", //电子资料->柴油资料库
        component: diesel_data
      }, {
        path: "multi-language", //汽车管理->多语言管理
        component: multi_language
      }, {
        path: "automobile-brand", //汽车管理->汽车品牌
        component: automobile_brand
      }, {
        path: "auto-indexing", //汽车管理->汽车索引
        component: auto_indexing,
        name: "auto_indexing"
      }, {
        path: "car-maintain", //老版车型管理->车系维护
        component: car_maintain
      }, {
        path: "emu-maintain", //老版车型管理->车组维护
        component: emu_maintain
      }, {
        path: "models-maintain", //老版车型管理->车型维护
        component: models_maintain
      }, {
        path: "models-file", //老版车型管理->车型文件
        component: models_file
      }, {
        path: "car-care-new", //新版车型管理->车系维护
        component: car_care_new
      }, {
        path: "emu-care-new", //新版车型管理->车组维护
        component: emu_care_new
      }, {
        path: "models-care-new", //新版车型管理->车型维护
        component: models_care_new
      }, {
        path: "models-car-file", //新版车型管理->车型文件维护
        component: models_car_file
      }, {
        path: "logo-type", //新版车型管理->车标类型维护
        component: logo_type
      }, {
        path: "logo-file", //新版车型管理->车标文件维护
        component: logo_file
      }, {
        path: "KMS-data-package", //ECU数据包管理->康明斯数据包
        component: KMS_data_package
      }, {
        path: "data_up_page", //ECU数据包管理->康明斯数据包->上传包
        component: data_up_page
      }, {
        path: "BS-data-package", //ECU数据包管理->博世数据包
        component: BS_data_package
      }, {
        path: "Other-data-package", //ECU数据包管理->其他数据包
        component: Other_data_package
      }, {
        path: "MP-data-package", //ECU数据包管理->马牌数据包
        component: MP_data_package
      }, {
        path: "NY-data-package", //ECU数据包管理->南岳数据包
        component: NY_data_package
      }, {
        path: "user-upload", //ECU数据包管理->南岳数据包
        component: user_upload
      }, {
        path: "sold-equipment", //已售设备管理->已售设备
        name: "sold_equipment",
        component: sold_equipment
      }, {
        path: "userAccredit", //已售设备管理->已售设备
        name: "userAccredit",
        component: userAccredit
      }, {
        path: "sold-equipment-new", //已售设备管理->已售设备->添加新用户
        component: sold_equipment_new,
        name: "sold_equipment_new"
      }, {
        path: "firmware-accredit-sold", //授权管理->固件授权
        component: firmware_accredit_sold,
        name: "firmware_accredit_sold"
      }, {
        path: "app-accredit-sold", //授权管理->app授权
        component: app_accredit_sold,
        name: "app_accredit_sold"
      }, {
        path: "extend-accredit-sold", //授权管理->扩展文件授权
        component: extend_accredit_sold,
        name: "extend_accredit_sold"
      }, {
        path: "model-accredit-sold", //授权管理->车型文件授权
        component: model_accredit_sold,
        name: "model_accredit_sold"
      }, {
        path: "sync-manage", //软件同步管理->一键同步
        component: sync_manage
      }, {
        path: "user-manage", //用户管理->用户账号列表
        name: 'user_manage',
        component: user_manage
      },
      /*{
        path: "account-data-record/:configID",//用户管理->用户账号列表->查看记录
        component: account_data_record,
        name:"account_config"
      },*/
      {
        path: "checkDetail-config/:configID", //用户管理->用户账号列表->查看记录->个人详情
        component: checkDetail_config,
        name: "checkDetail_config"
      }, {
        path: "authorize-config/:configID", //用户管理->用户账号列表->汽车诊断授权
        component: authorize_config,
        name: "authorize_config"
      }, {
        path: "record-config/:configID", //用户管理->用户账号列表->汽车诊断授权->授权记录
        component: record_config,
        name: "record_config"
      }, {
        path: "equipment-accredit", //授权管理->设备授权
        component: equipment_accredit,
        name: "equipment_accredit"
      }, {
        path: "firmware-accredit", //授权管理->固件授权
        component: firmware_accredit,
        name: "firmware_accredit"
      }, {
        path: "app-accredit", //授权管理->app授权
        component: app_accredit,
        name: "app_accredit"
      }, {
        path: "extend-accredit", //授权管理->扩展文件授权
        component: extend_accredit,
        name: "extend_accredit"
      }, {
        path: "model-accredit", //授权管理->车型文件授权
        component: model_accredit,
        name: "model_accredit"
      }, {
        path: "granted", //授权管理->查看已售设备授权
        component: granted,
        name: "granted"
      }, {
        path: "appeal-manage", //投诉管理->投诉列表
        component: appeal_manage
      }, {
        path: "diagnostic-report", //诊断管理->诊断报告
        component: diagnostic_report
      }, {
        path: "news-manage", //英文官网管理->新闻管理
        component: news_manage
      }, {
        path: "product-manage", //英文官网管理->产品管理
        component: product_manage
      }, {
        path: "photo-manage", //英文官网管理->图片管理
        component: photo_manage
      }, {
        path: "video-manage", //英文官网管理->视频管理
        component: video_manage
      }, {
        path: "anhui_news-manage", //安徽官网管理->新闻管理
        component: anhui_news_manage
      }, {
        path: "anhui_product-manage", //安徽官网管理->产品管理
        component: anhui_product_manage
      }, {
        path: "anhui_photo-manage", //安徽官网管理->图片管理
        component: anhui_photo_manage
      }, {
        path: "anhui_video-manage", //安徽官网管理->经销商管理
        component: anhui_video_manage
      }, {
        path: "anhui_recruit_manage", //安徽官网管理->招聘信息
        component: anhui_recruit_manage
      }, {
        path: "anhui_infomation_manage", //安徽官网管理->信息查询
        component: anhui_infomation_manage
      }, {
        path: "anhui_bussiness_manage", //安徽官网管理->服务介绍
        component: anhui_bussiness_manage
      }, {
        path: "Russian-news", //俄文官网管理->新闻管理
        component: Russian_news
      }, {
        path: "Russian-product", //俄文官网管理->产品管理
        component: Russian_product
      }, {
        path: "Russian-photo", //俄文官网管理->图片管理
        component: Russian_photo
      }, {
        path: "Russian-video", //俄文官网管理->视频管理
        component: Russian_video
      }, {
        path: "Russian-information", //俄文官网管理->信息管理
        component: Russian_information
      }, {
        path: "Russian-services", //俄文官网管理->视频管理
        component: Russian_services
      },
      /*      {path:"Russian-information",//俄文官网管理->视频管理
         component:  Russian_information
       },
        {
         path:"Russian-concat",//俄文官网管理->视频管理
         component: Russian_concat
       },*/
      {
        path: "Chinese-news", //中文官网管理->新闻管理
        component: Chinese_news
      }, {
        path: "Chinese-photo", //中文官网管理->新闻管理
        component: Chinese_photo
      }, {
        path: "Chinese-product", //中文官网管理->产品管理
        component: Chinese_product
      }, {
        path: "Chinese-report", //中文官网管理->年报
        component: Chinese_report
      }, {
        path: "Chinese-Notice", //中文官网管理->公告
        component: Chinese_Notice
      }, {
        path: "Chinese-Recruit", //中文官网管理->招聘信息Chinese_Notice
        component: Chinese_Recruit
      }, {
        path: "Chinese-search", //中文官网管理->招聘信息Chinese_Notice
        component: Chinese_search
      }, {
        path: "Chinese-Business", //中文官网管理->服务介绍
        component: Chinese_Business
      }, {
        path: "diesel-fault", //故障码->柴油故障码
        component: diesel_fault
      }, {
        path: "firmware-synchronous", //软件同步->固件
        component: firmware_synchronous
      }, {
        path: "app-synchronous", //软件同步->app
        component: app_synchronous
      }, {
        path: "car-synchronous", //软件同步->车型
        component: car_synchronous
      }, {
        path: "change-machine", //换机数据->换机数据
        component: change_machine
      }]
    }]
  }]
}));

/***/ }),

/***/ "aubk":
/***/ (function(module, exports) {



/***/ }),

/***/ "bqLE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
  //记录所有用户点击过的导航，包括之前有重复的点击
  setActiveNav: function setActiveNav(state, navData) {
    state.active_nav.push(navData);
  },

  //替换整个active_nav
  checkAllActiveNav: function checkAllActiveNav(state, navData) {
    state.active_nav = navData;
  },

  //当前点击的导航的cusindex
  setiNow: function setiNow(state, iNow) {
    state.active_iNow = iNow;
  },

  //pub-head中导航和tab的对应数据
  settabVisible: function settabVisible(state, data) {
    state.tabVisible.push(data);
  },

  //整体替换vueX中的tabVisible
  checkAllTabVisible: function checkAllTabVisible(state, tabData) {
    state.tabVisible = tabData;
  },

  //设置点击tab标签的高亮
  setActiveTab: function setActiveTab(state, data) {
    for (var i = 0; i < state.tabVisible.length; i++) {
      state.tabVisible[i].isActive = false;
    }
    for (var i = 0; i < state.tabVisible.length; i++) {
      if (state.tabVisible[i].cusindex == data) {
        state.tabVisible[i].isActive = true;
      }
    }
  },

  //设置在售机型tab标签的machineNewOnOff
  setMachineNewOnOff: function setMachineNewOnOff(state, bool) {
    state.machineNewOnOff = bool;
  },


  //车型数据授权->查看记录 子项tab页打开，则将该子项目的cusindex存入
  setCarData: function setCarData(state, data) {
    state.carData.push(data);
  },

  //车型数据授权->查看记录 替换整个carData
  checkAllCarData: function checkAllCarData(state, data) {
    state.carData = data;
  },

  //车型数据授权->查看记录 某子项tab页关闭，则将该子项的cusindex清除
  delCarData: function delCarData(state, data) {
    for (var i = 0; i < state.carData.length; i++) {
      if (state.carData[i] == data) {
        state.carData.splice(i, 1);
      }
    }
  },


  //用户管理->用户账号列表 子项tab页打开，则将该子项目的cusindex存入
  setAccountData: function setAccountData(state, data) {
    state.accountData.push(data);
  },

  //用户管理->用户账号列表 替换整个carData
  checkAllAccountData: function checkAllAccountData(state, data) {
    state.accountData = data;
  },

  //用户管理->用户账号列表 某子项tab页关闭，则将该子项的cusindex清除
  delAccountData: function delAccountData(state, data) {
    for (var i = 0; i < state.accountData.length; i++) {
      if (state.accountData[i] == data) {
        state.accountData.splice(i, 1);
      }
    }
  },


  //用户管理->用户账号列表->产品保修信息 子项tab页打开，则将该子项目的cusindex存入
  setProductWarranty: function setProductWarranty(state, data) {
    state.productWarranty.push(data);
  },

  //用户管理->用户账号列表->产品保修信息 替换整个productWarranty
  checkAllProductWarranty: function checkAllProductWarranty(state, data) {
    state.productWarranty = data;
  },

  //用户管理->用户账号列表->产品保修信息 某子项tab页关闭，则将该子项的cusindex清除
  delProductWarranty: function delProductWarranty(state, data) {
    for (var i = 0; i < state.productWarranty.length; i++) {
      if (state.productWarranty[i] == data) {
        state.productWarranty.splice(i, 1);
      }
    }
  },


  //用户管理->用户账号列表->授权 子项tab页打开，则将该子项目的cusindex存入
  setProductAuthorize: function setProductAuthorize(state, data) {
    state.productAuthorize.push(data);
  },

  //用户管理->用户账号列表->授权 替换整个productAuthorize
  checkAllProductAuthorize: function checkAllProductAuthorize(state, data) {
    state.productAuthorize = data;
  },

  //用户管理->用户账号列表->授权 某子项tab页关闭，则将该子项的cusindex清除
  delProductAuthorize: function delProductAuthorize(state, data) {
    for (var i = 0; i < state.productAuthorize.length; i++) {
      if (state.productAuthorize[i] == data) {
        state.productAuthorize.splice(i, 1);
      }
    }
  },


  //用户管理->用户账号列表->授权->授权记录 子项tab页打开，则将该子项目的cusindex存入
  setHistoryAuthorize: function setHistoryAuthorize(state, data) {
    state.historyAuthorize.push(data);
  },

  //用户管理->用户账号列表->授权->授权记录 替换整个productAuthorize
  checkAllHistoryAuthorize: function checkAllHistoryAuthorize(state, data) {
    state.historyAuthorize = data;
  },

  //用户管理->用户账号列表->授权->授权记录 某子项tab页关闭，则将该子项的cusindex清除
  delHistoryAuthorize: function delHistoryAuthorize(state, data) {
    for (var i = 0; i < state.historyAuthorize.length; i++) {
      if (state.historyAuthorize[i] == data) {
        state.historyAuthorize.splice(i, 1);
      }
    }
  },


  //在登陆的时候改变这个值为true;但是刷新的时候，我们不改变，即为false
  setPageRefreshOnOff: function setPageRefreshOnOff(state, bool) {
    state.pageRefreshOnOff = bool;
  },

  //设置某个tab标签的隐藏
  setHideTab: function setHideTab(state, data) {
    var vehicle_reg = /^vehicle/;
    var account_reg = /^account/;
    var warranty_reg = /^warranty/;
    var authorize_reg = /^authorize/;
    var record_reg = /^record/;
    var marchine_reg = /^machine/;
    for (var i = 0; i < state.tabVisible.length; i++) {
      if (vehicle_reg.test(data) || account_reg.test(data) || warranty_reg.test(data) || authorize_reg.test(data) || record_reg.test(data) || marchine_reg.test(data)) {
        //如果删除的是新加的machine,则从数组中删除
        if (state.tabVisible[i].cusindex == data) {
          state.tabVisible.splice(i, 1);
        }
      } else {
        //否则隐藏
        if (state.tabVisible[i].cusindex == data) {
          state.tabVisible[i].orShow = false;
        }
      }
    }
  },

  //当删除标签页的时候，同时需要相应地删除active_nav
  changeActiveNav: function changeActiveNav(state, navData) {
    //从state.active_nav删除navData,不过先要去重
    var duplicate = state.active_nav;
    var array_temp = [];
    for (var i = 0, l = duplicate.length; i < l; i++) {
      for (var j = i + 1; j < l; j++) {
        if (duplicate[i] === duplicate[j]) j = ++i;
      }array_temp.push(duplicate[i]);
    }

    for (var i = 0; i < array_temp.length; i++) {
      if (array_temp[i] == navData) {
        array_temp.splice(i, 1);
      }
    }
    state.active_nav = array_temp;
  },
  emptyNav: function emptyNav(state) {
    state.active_nav = [];
  },

  //tab页签右键关闭其它，active_nav只存储点击的cusindex
  setOnlyNav: function setOnlyNav(state, cusindex) {
    var vehicle_reg = /^vehicle/;
    var account_reg = /^account/;
    var warranty_reg = /^warranty/;
    var authorize_reg = /^authorize/;
    var record_reg = /^record/;
    var marchine_reg = /^machine/;
    state.active_nav = [];
    state.active_nav.push(cusindex);
    state.carData = [];
    state.accountData = [];
    state.productWarranty = [];
    state.productAuthorize = [];
    state.historyAuthorize = [];

    if (vehicle_reg.test(cusindex)) {
      state.carData.push(cusindex);
    } else if (account_reg.test(cusindex)) {
      state.accountData.push(cusindex);
    } else if (warranty_reg.test(cusindex)) {
      state.productWarranty.push(cusindex);
    } else if (authorize_reg.test(cusindex)) {
      state.productAuthorize.push(cusindex);
    } else if (record_reg.test(cusindex)) {
      state.historyAuthorize.push(cusindex);
    } else if (marchine_reg.test(cusindex)) {
      state.machineNewOnOff = false;
    }
  },

  //tab页签右键关闭其它，tabVisible中只有点击的cusindex的orShow和isActive等于true
  setOnlyShowNav: function setOnlyShowNav(state, cusindex) {
    console.log(cusindex);
    //先判断点击的cusindex是否在原始的tabVisible中，比如历史记录，售机类型配置，维修记录都不在原始的tabVisible中
    var onoff = false;
    for (var i = 0; i < state.tabVisible_original.length; i++) {
      if (state.tabVisible_original[i].cusindex == cusindex) {
        onoff = true;
      }
    }
    //车型数据授权tab页、用户账号列表tab页
    var obj_temp = {};
    if (!onoff) {
      for (var i = 0; i < state.tabVisible.length; i++) {
        if (state.tabVisible[i].cusindex == cusindex) {
          obj_temp = state.tabVisible[i]; //选取这些特定的对象集
          break;
        }
      }
    }
    console.log(obj_temp);

    state.tabVisible = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.tabVisible_original)); //重置tabVisible
    console.log(state.tabVisible);
    if (onoff) {
      //如果原始tabVisible中有
      for (var i = 0; i < state.tabVisible.length; i++) {
        if (state.tabVisible[i].cusindex == cusindex) {
          state.tabVisible[i].orShow = true;
          state.tabVisible[i].isActive = true;
        }
      }
    } else {
      for (var i = 0; i < state.tabVisible.length; i++) {
        state.tabVisible[i].orShow = false;
        state.tabVisible[i].isActive = false;
      }
      state.tabVisible.push(obj_temp);
    }
  },
  resetAllData: function resetAllData(state) {
    state.active_nav = [];
    state.active_iNow = "";
    state.carData = [];
    state.accountData = [];
    state.productWarranty = [];
    state.productAuthorize = [];
    state.historyAuthorize = [];
    state.machineNewOnOff = true;
    state.pageRefreshOnOff = false;
    state.tabVisible = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.tabVisible_original));
  }
});

/***/ }),

/***/ "fhKr":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJdJREFUeNpibGho8GNgYPhYX19/kAENNDY22gMpfiYg8QWI10EF0BWsA8kz/v//HyTgBOSsBuIgkIlICkKB/H1gRVCdMIUdQFwBUwCSgyuCKiwFUl1AXAZU0A0TZ0JzA8iEMhANNRmhCCoAcwPIhFCQ1TCFzIyMjDC3wN3g4OBw/+DBg2dA4iAaZBIPsgIYgPJBJvIABBgArx1JPyk4sToAAAAASUVORK5CYII="

/***/ }),

/***/ "k3yR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return address; });
// export const address = "http://192.168.3.213:8080/FcarOperateWeb/";
// export const address = "http://192.168.3.100:8080/FcarOperateWeb/";
var address = "http://www.szcitycar.com/";
// export const address = "http://192.168.3.91:8080/";
// export const address = "http://192.168.3.164:8080/FcarOperateWeb/";
// export const address = "http://192.168.3.91:8080/FcarOperateWeb/";
// export const address = "http://192.168.3.53:8098/FcarOperateWeb/";
// export const address = "http://192.168.3.226:8080/FcarOperateWeb/";
// export const address = "http://client.szfcar.com/";

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },
  created: function created() {

    //用户刷新之后，需要检测sessionStorage里面的session_carData、session_accountData是否有值，如果有值，需要根据sessionStorage同步更新vueX中的carData、accountData
    var sessionCarData = JSON.parse(sessionStorage.getItem("session_carData"));
    if (sessionCarData && sessionCarData.length > 0) {
      this.$store.commit("checkAllCarData", sessionCarData); //根据sessionStorage替换整个vueX中carData
    }

    var sessionAccountData = JSON.parse(sessionStorage.getItem("session_accountData"));
    if (sessionAccountData && sessionAccountData.length > 0) {
      this.$store.commit("checkAllAccountData", sessionAccountData); //根据sessionStorage替换整个vueX中accountData
    }

    var sessionProductWarranty = JSON.parse(sessionStorage.getItem("session_productWarranty"));
    if (sessionProductWarranty && sessionProductWarranty.length > 0) {
      this.$store.commit("checkAllProductWarranty", sessionProductWarranty); //根据sessionStorage替换整个vueX中productWarranty
    }

    var sessionproductAuthorize = JSON.parse(sessionStorage.getItem("session_productAuthorize"));
    if (sessionproductAuthorize && sessionproductAuthorize.length > 0) {
      this.$store.commit("checkAllProductAuthorize", sessionproductAuthorize); //根据sessionStorage替换整个vueX中productWarranty
    }

    var sessionHistoryAuthorize = JSON.parse(sessionStorage.getItem("session_historyAuthorize"));
    if (sessionHistoryAuthorize && sessionHistoryAuthorize.length > 0) {
      this.$store.commit("checkAllHistoryAuthorize", sessionHistoryAuthorize); //根据sessionStorage替换整个vueX中productWarranty
    }

    var sessionMachineNewOnOff = sessionStorage.getItem("session_machineNewOnOff");
    if (sessionMachineNewOnOff == "true") {
      this.$store.commit("setMachineNewOnOff", true);
    } else {
      this.$store.commit("setMachineNewOnOff", false);
    }

    this.$store.commit("setPageRefreshOnOff", false); //改变vueX中的setPageRefreshOnOff为false
    // this.getSession();
  },
  mounted: function mounted() {
    /*tab页右键弹出层，鼠标滑过li选项时的事件start*/
    $(document).off("click", ".contextLists .contextListsSub").on("mouseover", ".contextLists .contextListsSub", function () {
      $(this).addClass("contextListsSubActive");
    });
    $(document).off("click", ".contextLists .contextListsSub").on("mouseout", ".contextLists .contextListsSub", function () {
      $(this).removeClass("contextListsSubActive");
    });
    /*tab页右键弹出层，鼠标滑过li选项时的事件end*/

    /*点击document(除右键弹出层本身),关闭tab页弹出层start*/
    $(document).off("click").on("click", function (event) {
      if (!$(event.target).hasClass("contextLists")) {
        $(".contextLists").remove();
      }
    });
    /*点击document(除右键弹出层本身),关闭tab页弹出层end*/
  },

  methods: {
    //请求后台的sessionAPI，如果没过期，就跳过登录页
    getSession: function getSession() {
      var _this = this;

      /*刷新调整--start*/
      $.ajax({
        type: "POST",
        url: "/NetworkTeachSystem/admin/session",
        contentType: "application/json;charset=UTF-8",
        async: false,
        success: function success(data) {
          //console.log(data);
          var active_iNow = sessionStorage.getItem("session_active_iNow"); //当前点击的iNow
          var session_login = sessionStorage.getItem("session_login"); //session_login在点击登陆之后会产生值，所以可以用它来判断未
          if (!data.status) {
            _this.$router.push({ path: "/index" }); //跳转到登录页
          } else {
            if (!active_iNow && session_login) {
              //假如session未过期，但是active_iNow没值，说明没有任何导航选中，路由展示初始化引导界面
              var cusRoute = "/main-page";
              _this.$router.push({ path: cusRoute }); //跳过登录页,跳转至相应路由页面
            }
            if (!active_iNow && !session_login) {
              //关闭了浏览器，重新打开之前复制的网址，这两个sessionStorage值都为空，就跳转到登录页
              _this.$router.push({ path: "/index" }); //跳转到登录页
            }
          }
        },
        error: function error(XMLHttpRequest, textStatus, errorThrown) {
          console.log(textStatus + ":" + XMLHttpRequest.status);
        }
      });
      /*刷新调整----end*/
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.00411e9f10598755a340.js